import { render, staticRenderFns } from "./BaseSubmitInfoModal.vue?vue&type=template&id=318a8ca9&scoped=true&"
import script from "./BaseSubmitInfoModal.vue?vue&type=script&lang=js&"
export * from "./BaseSubmitInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a8ca9",
  null
  
)

export default component.exports